<script>
// @ is an alias to /src
import Layout from "@/layout/Main.vue";
import NoImageUrl from "@/assets/no-image.png";

export default {
	components: {
		Layout
	},

	data () {
		return {
			NoImageUrl,
			publicPath: process.env.BASE_URL,
			style: null,
			restaurant: [],

			restaurant_id: '1',
			branch_id: '11',
			device_token:'',

			token: '',
			uid: '',

			offers: [],
			coupons: [],
			promotions:[],
			offer_code: "",
			selection_list: [],
			selectedItems: [],
			quantity: "",

			checkbox_values:[],

			productPrice: [],
			subtotal: '',

			checkout_Products : [],

			coupon: [],
			
		}
	},


	created() {
		  this.style = document.createElement('link')
		  this.style.setAttribute('rel', 'stylesheet')
		  this.style.setAttribute('href', '/design/offers.css')
		  document.head.appendChild(this.style)
	},

	beforeDestroy() {
		document.head.removeChild(this.style);
	},

     mounted() {
         this.fetchOffers();
		 //this.copyCouponCode();
      },
      methods: {

		getToken() {
			if (localStorage.getItem('sigofood_user')) {
				var sigofood_user =  JSON.parse(localStorage.getItem('sigofood_user'));
				if(sigofood_user.token) {
				this.token = sigofood_user.token;
				this.uid = sigofood_user.uid;

				} else {
				this.$swal("", "Failed to fetch token, please login again", "error");
				this.$router.push({ name: "login" });
				}
				
			} else if(localStorage.getItem('sigofood_guest')) {
				var sigofood_guest =  JSON.parse(localStorage.getItem('sigofood_guest'));
				if(sigofood_guest.token) {
				this.guestToken = sigofood_guest.token;

				} else {
				this.$swal("", "Failed to fetch token, please login again", "error");
				this.$router.push({ name: "login" });
				}
			} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
			}
        }, 

		fetchLocation() {

			if (localStorage.getItem('sigofood_location')) {
				var sigofood_location =  JSON.parse(localStorage.getItem('sigofood_location'));
				this.latitude = sigofood_location.latitude;
				this.longitude = sigofood_location.longitude;
				this.block_no = sigofood_location.block_no;
				this.location = sigofood_location;

			} else {
				this.$router.push({ name: "location" });
			}
		}, 

        fetchOffers() {
			this.fetchLocation();
			this.getToken();

            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,

               },
            };
               let url = "offers?latitude=" + this.latitude + "&longitude=" + this.longitude + "&block_no=" + this.block_no;          

               this.$axios
                  .get(url, config)
                  .then((res) => {
                    if(res.status == 200) {
                        var responseData = res.data.data;
                        console.log(responseData);
						this.coupons = responseData.coupons;

						for(var i=0; i < this.coupons.length; i++) {
							this.coupons[i].copied = 0;
						}

						console.log('init');
						console.log(this.coupons);

						this.promotions = responseData.promotions;
						if(responseData.promotions.length) {
							this.branch_id = responseData.promotions[0].branch_id;
						}

						console.log(this.coupons);
                        
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }                  
               })
               .catch((error) => {
                  if (error.response) {
                     if(error.response.status == 422) {               
                        if (error.response.data) {
                           this.errors = error.response.data.message;
                        } 
                        this.$swal("", error.response.statusText, "error");
                        
                     } else if(error.response.status == 500) {
                        this.$swal("", error.response.statusText, "error");

                     } else if(error.response.status == 401) {
                        this.$swal("", error.response.statusText, "error");
                        this.$router.push({ name: "login" });
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", error.message, "error");
                  }
               })
               .finally(() => (this.loading = false));
        },

		copyCouponCode(coupon, index) {
			//alert(index);
				for(var i = 0; i < this.coupons.length; i++) {
					//this.copied[i] = 0;
					this.coupons[i].copied = 0;
				}
				console.log('clear');
				console.log(this.coupons);
				// //var copied = this.copied;
				//var couponCode = coupon.offer_code; 
					
				// 	// navigator.clipboard.writeText(couponCode).then(() => {
				// 	// //alert("Coupon code copied to clipboard!");
					
				// 	// }, () => {
				// 	// // alert("Failed to copy coupon code to clipboard!");
				// 	// });
				// 	document.execCommand('copy');
				// 	this.coupons[index].copied = 1;
				// 	//alert(this.copied[index]);
				// 	//console.log(this.copied);
				// 	//this.copied = copied;

				const el = document.createElement('textarea');  
	        el.value = coupon.offer_code;                                 
	        // el.setAttribute('readonly', '');                
	        // el.style.position = 'absolute';                     
	        // el.style.left = '-9999px';                      
	        document.body.appendChild(el);                  
	        const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;                                    
	        el.select();                                    
	        document.execCommand('copy');                   
	        document.body.removeChild(el);                  
	        if (selected) {                                 
	          document.getSelection().removeAllRanges();    
	          document.getSelection().addRange(selected);   
	        }
	        this.coupons[index].copied = 1;
	        //alert(this.coupons[index].copied);
	        console.log(this.coupons);
		},

		showModal(modal) {
         this.$refs[modal].show();
		},

		hideModal(modal) {
			this.$refs[modal].hide();
		}, 

		promotionDetails(pr_id) {
			this.getToken();

				if(localStorage.getItem('sigofood_uid')) {
						this.uid = localStorage.getItem('sigofood_uid');  
					} 

				const config = {
				headers: {
					"Content-type": "multipart/form-data",
					"Accept": "application/json",
					"Authorization": "Bearer " + this.token,

				},
				};
				let url = "promotions/details";  

				let formData = new FormData();
				formData.append("promotion_id", pr_id);
				
				this.$axios
					.post(url, formData, config)
					.then((res) => {
						if(res.status == 200) {
							var responseData = res.data;
							console.log(responseData);
							this.pro_details = responseData.data;
							this.selection_list = responseData.data.selection_list;
							this.r_id = responseData.data.r_id;
							this.pr_id = responseData.data.pr_id;
							this.restaurant = responseData.data.rest_name;

							console.log(this.pro_details);
							console.log(this.selection_list);
							this.checkout_Products = [];
							this.showModal("products-modal");

							
						} else {
							this.$swal("", "Something went wrong", "error");
						}                  
				})
				.catch((error) => {
					if (error.response) {
						if(error.response.status == 422) {               
							if (error.response.data) {
							this.errors = error.response.data.message;
							} 
							this.$swal("", error.response.statusText, "error");
							
						} else if(error.response.status == 500) {
							this.$swal("", error.response.statusText, "error");

						} else if(error.response.status == 401) {
							this.$swal("", error.response.statusText, "error");
							this.$router.push({ name: "login" });
							
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					} else {
						this.$swal("", error.message, "error");
					}
				})
				.finally(() => (this.loading = false));
 

		},

		setPrice() {
			this.productPrice = [];
			var getboxvalues = [];
			this.getProId = [];
			this.selection_qty = [];
			
			getboxvalues = this.checkbox_values;
			console.log(getboxvalues);

			getboxvalues.forEach(obj => {
			 obj = obj.split("_");
			 this.productPrice.push(obj[1]);
			});

			getboxvalues.forEach(obj => {
			 obj = obj.split("_");
			 this.selection_qty.push(obj[6]);
			});
			console.log(this.selection_qty);

			let total = 0;
			this.productPrice.forEach(val => {
				total += Number(val);
			});

			getboxvalues.forEach(obj => {
			 obj = obj.split("_");
			 this.getProId.push(obj[0]);
			});

			this.subtotal = total;

			var ob = {};

			getboxvalues.forEach(obj => {
				obj = obj.split("_");
				ob.product_name_english = obj[2];
				ob.product_id = obj[4];
				ob.price_id = obj[3];
				ob.cat_id = obj[5];
				ob.price = obj[1];
			});

			this.checkout_Products.push(ob);
			console.log(this.checkout_Products);
			
		},

		submitCheckout() {
			var checkout_data = {};
			var product_count = '';
			checkout_data.products = this.checkout_Products;
			product_count = checkout_data.products.length;

			if( product_count < this.selection_qty) {
				alert("please choose the required quantity");
				window.location.reload();
			}
			checkout_data.subtotal = this.subtotal;
			checkout_data.branch_id = this.branch_id;
			checkout_data.pr_id = this.pr_id;
			checkout_data.r_id = this.r_id;
			checkout_data.restaurant = this.restaurant;
			console.log(checkout_data);
			localStorage.setItem('promotion_checkout_data', JSON.stringify(checkout_data));

			this.$router.push({ name: "promotion-checkout" });
			
		}
               
	}

		

}
</script>
	
	
	
<template>
	<Layout>			

		<div class="banner">
			<img src="/design/sigofood-images/slider3.png"  alt="slider1" class="slide d-block w-100 ">      
		</div>

		<!--Restaurant Offers-->
		<div class="container mt-5">
			<h3 class="offers">Restaurant Offers</h3>
			<h6 class="offers">Explore top offers from restaurants exclusively for you!</h6>
		</div>

		
		<div class="container-sm">

			<div class="row mt-5 mb-5" v-if="coupons.length">
				<div class="col-xl-4 col-lg-4 col-md-6" v-for="(coupon, index) in coupons" :key="coupon.c_id">
					<div class="card offer-card" >
						<!-- <router-link :to="{ name: 'restaurant-details ',params: {id: restaurant.r_id,branch_id: restaurant.branch_id } }" > -->
							<div v-if="coupon.rest_image" class="restaurant-image"  :style="{ 'background-image': 'url(' + $image_url + coupon.rest_image + ')' }"></div>
							<div v-else  class="restaurant-image" :style="{ backgroundImage: `url(${NoImageUrl})` }" ></div>
						<!-- </router-link> -->
						<div class="card-body">
							<div class="row">
							  	<div class="col-7">
									<h5 class="card-title restaurant-name">
										{{ coupon.restaurant }}
									</h5>
							  	</div>

							  	<div class="col-5 ">
									<div class="d-flex" style="justify-content: end;">
										<img src="/design/sigofood-images/offer.png" style="width: 18px; height: 18px;">
										<p class="off">{{coupon.percentage}}% off</p>
									</div>
								</div>
							  	
							</div>					
							
							<div class="row">
								<div class="col-6">
									<p class="coupon-title">{{coupon.title}}</p>
								</div>
								<div class="col-6">
									<p class="coupon-code">Coupon Code: <span>{{coupon.offer_code}}</span></p>
									<div v-if="parseInt(coupon.copied)==1" class="d-flex justify-content-end"><p class="dtime">Copied  <i class="material-icons">check_circle</i></p></div>
									<div v-else class="d-flex justify-content-end"><a href="#" class="dtime" @click.prevent="copyCouponCode(coupon, index)"><p class="mb-0">COPY <i class="material-icons">content_copy</i></p></a></div>
									
								</div>
							</div>

							<div class="row">
								<div class="col-12">
									<p class="coupon-des mb-0">{{coupon.description}}</p>
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>

			<!--Promotions-->
			<!-- <div class="row" >
				<h5 class="offers-des">Promotions</h5>
				<div class="col-xl-6 col-lg-4 col-md-6" v-for="(promotion) in promotions" :key="promotion.pr_id" style="margin-bottom: 50px;">
					<div class="card"  style="box-shadow: 1px 1px 1px 1px rgba(213, 211, 211, 0.63);" >
							
						<div class="card-body"  @click="promotionDetails(promotion.pr_id)" >
							<div class="row">
								<div class="col">
									<div class="col-sm-4">
										<div class="circle">
											<span class="data">{{ promotion.code }}</span>
										</div>
									</div>
								</div>
								<div class="col-sm-8" style="margin-left: 0px;">
									<p class="coupon-title">{{promotion.title}}</p>
									<p class="coupon-des">{{promotion.description}}</p>
									<p class="TC">Other T&Cs may apply</p>
								</div>
							</div>
									
						</div>
					</div>
				</div>
			</div> -->
					
			<!--Promotions checkout modal-->
			<b-modal ref="products-modal" id="products-modal" hide-footer>
				<div style="margin-left: 10px; margin-right: 10px;">
					<div  v-for="(selection) in selection_list" :key="selection.sel_id" style="margin-bottom: 50px;">
						<span style="font-weight: bold;">{{ selection.cat_name }}
						<span style="font-weight: bold; padding-right: 10px;" >QTY - {{ selection.quantity }}</span>
						</span>
								
						<div >
							<div class="row g-0" style="padding-top: 15px; padding-bottom: 15px; padding-left: 30px; ">
										
								<div class="col-md-10">
									<div class="card-body">
										<div class="row">
													
											<div class="col">
												<div class="row">
													<div class="col" style="margin-left: 30px;">
														<b-form-checkbox-group   v-model="checkbox_values">
														<b-form-checkbox v-for="product in selection.products" :key="product.product_id"  :value="product.ppro_id + '_' + product.price + '_' + product.name + '_' + product.price_id + '_' + product.product_id + '_' + product.cat_id + '_' + selection.quantity"  @change="setPrice()" style="box-shadow: 0px 0px 1px 0px rgba(160, 157, 157, 0.63);  background-color: rgb(245, 244, 244);">
														<div class="row" style="padding-top:15px; padding-bottom: 15px;">
															<img v-if="product.image" :src="$image_url + product.image" class="img-fluid rounded-start" alt="pepsi" style="margin-right: 0px; height: 70px; width: 80px;"/>
															<div class="col" style="margin-left: 15px;">
															<h5 class="card-title">{{product.name}} </h5>
															<p class="card-text"><small class="text-muted">{{product.price}} BHD</small></p>
														</div>	
													</div>																
													</b-form-checkbox>
												</b-form-checkbox-group>
															</div>
														</div>
													</div>

												</div>
											</div>
										</div>
									</div>
								</div>		
							</div>
						</div>
						<div class="apply_button">
							<a class="btn checkout"  role="button"  @click="submitCheckout()" >Apply</a>
						</div>
					</b-modal>
				</div>


		</Layout>
	</template>


